/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountListRequest {
    getFixupPrototypeFunction() { return ServiceAccountListRequest.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountListRequest>): ServiceAccountListRequest {
        let obj = Object.assign(new ServiceAccountListRequest(), model);
        ServiceAccountListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountListRequest>): ServiceAccountListRequest {
        if (!model) return null;
        return ServiceAccountListRequest.newInstance(<ServiceAccountListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountListRequest) {
        if (!obj) return;

        models.ServiceAccountListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountListRequest): boolean {
        Object.setPrototypeOf(obj, ServiceAccountListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.ServiceAccountFilter.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.ServiceAccountSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.ServiceAccountSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.ServiceAccountFilter;

}
